import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface PrivateRouteProps {
  allowedClaims: string[];
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ allowedClaims }) => {
  const { isAuthenticated, authLoading, userClaims } = useAuth();

  // Wait for localStorage check before making auth decisions
  if (authLoading) {
    return null; // or a small spinner — avoids premature redirect on refresh
  }

  // If not authenticated, redirect to login page
  if (!isAuthenticated) {
    return <Navigate to="/login/" />;
  }

  // Check if the user has one of the allowed claims
  const hasRequiredClaim = allowedClaims.some((claim) => userClaims.includes(claim));

  // If no valid claim, redirect to unauthorized page
  if (!hasRequiredClaim) {
    return <Navigate to="/unauthorized/" />;
  }

  // Allow access if authenticated and has the correct claim
  return <Outlet />;
};

export default PrivateRoute;
